import React from "react";

type SelectConsultingTypeProps = {
  value: string;
  onChange?: (value: string) => void;
};

const options = [
  { label: "Day", value: "day" },
  { label: "Evening", value: "evening" },
];

export function SelectConsultingType({
  value,
  onChange,
}: SelectConsultingTypeProps) {
  return (
    <select
      className="bg-[#23272f] text-white border border-gray-700 rounded-lg px-2 py-1"
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
    >
      <option value="" disabled>
        Select Consulting Type
      </option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
// Removed duplicate implementation of SelectConsultingType
